export const DisplayTypeProject = 'project'
export const DisplayTypeTvOrVideo = 'tvOrVideo'
export const DisplayTypeWebinar = 'webinar'
export const DisplayTypeWhitepaper = 'whitepaper'
export const DisplayTypeRegistrationForm = 'registrationForm'
export const DisplayTypeArticle = 'article'
export const DisplayTypeJudgeTeam = 'judgeTeam'

const ProjectDisplayTypes = [DisplayTypeProject, DisplayTypeTvOrVideo, DisplayTypeWebinar, DisplayTypeWhitepaper, DisplayTypeRegistrationForm, DisplayTypeArticle, DisplayTypeJudgeTeam]

export default {
  data: function () {
    return {
      DisplayTypeProject,
      DisplayTypeTvOrVideo,
      DisplayTypeWebinar,
      DisplayTypeWhitepaper,
      DisplayTypeRegistrationForm,
      DisplayTypeArticle,
      DisplayTypeJudgeTeam,
      ProjectDisplayTypes
    }
  }
}
